module.exports = __webpack_public_path__ + "998d9bd9eef09cada092c915ae67bdd9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/log-cabin-empty.png
// module id = 326
// module chunks = 0